import update from "immutability-helper";
import { handle } from "redux-pack";
import { LIST, DESTROY, SET_PAGE } from "./actions";

const initialState = {
  all: {
    loading: false,
    items: [],
    included: [],
  },
  pagination: {
    currentPage: 1,
    perPage: null,
    totalPages: null,
    totalRecords: null,
  },
};

function reducer(state = initialState, action) {
  const { type, payload } = action;
  const { data: json } = payload || {};
  switch (type) {
    case LIST:
      return handle(state, action, {
        start: (prevState) => {
          return update(prevState, {
            all: {
              loading: { $set: true },
            },
          });
        },

        failure: (prevState) => {
          return update(prevState, {
            all: {
              loading: { $set: false },
            },
          });
        },

        success: (prevState) => {
          return update(prevState, {
            all: {
              items: { $set: json.data },
              included: { $set: json.included },
              loading: { $set: false },
            },
            pagination: { $set: json.meta.pagination },
          });
        },
      });

    case DESTROY:
      return handle(state, action, {
        success: (prevState) => {
          const invitationId = action.meta.invitationId;
          let invitations = { ...prevState.all };
          invitations.items = invitations.items.filter((invitation) => invitation.id !== invitationId);
          return update(prevState, {
            all: { $set: invitations },
          });
        },
      });

    case SET_PAGE:
      return update(state, {
        pagination: {
          currentPage: { $set: payload.page },
        },
      });

    default:
      return state;
  }
}

export default reducer;
